declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export type AnalyticsEvent =
  | 'parent_signup_cta'
  | 'therapist_marketplace_cta'
  | 'pricing_cta'
  | 'contact_submit'
  | 'sign_in_click'
  | 'iep_goal_coach_cta'
  | 'resource_download'
  | 'demo_contact';

/** Fire GA4 custom events when gtag is available. */
export function trackEvent(event: AnalyticsEvent, params: Record<string, string | number | boolean> = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    }
  } catch {
    // analytics must never break UX
  }
}

/** SPA virtual pageview for History API navigations. */
export function trackPageView(path: string, title?: string) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_title: title || document.title,
        page_location: `https://www.tinywins.ai${path === '/' ? '' : path}`,
      });
    }
  } catch {
    // ignore
  }
}
